import React, { useEffect, useState, useContext } from 'react'
import { getLatestSongsEU, getSonglistURL } from '../../utils/api'
import { Pagination } from '../helpers/Pagination'
import { Box, Flex, Heading, Stack } from '@chakra-ui/react'
import { getTime } from '../../utils/convert-time'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { Loading } from '../helpers/Loading'
import { MusicPlayerContext } from '../../context/MusicPlayerContext'
import { RiHeartLine, RiPlayLine, RiPauseLine } from 'react-icons/ri'

/** ListView: LATEST MUSIC IN EUROPE **/
export const LatestTrackslist = () => {
  const [tracks, setTracks] = useState( [] )
  const [totalResults, setTotalResults] = useState( 0 )
  const [resultsPerPage] = useState( 20 )
  const [currentPage, setCurrentPage] = useState( 1 )
  const [loading, setLoading] = useState( false )
  const { isPlaying, currentTrackName, playTrack, togglePlay, trackList, currentIndex } = useMusicPlayer( tracks )
  const [state, setState] = useContext( MusicPlayerContext )
  let id

  useEffect( () => {
    async function latestTopSongss() {
      setLoading( true )
      const latestTracks = await getLatestSongsEU()
      let ids = latestTracks.map( id => id.id )
      let urls = await getSonglistURL( ids )
      const songsArray = latestTracks.map( song => {
        urls.map( url => {
          if ( song.id === url.id ) {
            song.url = url.url
            song.id = id
          }
          return url
        } )
        return song
      } )
      // console.log( urls, "urls" )
      setLoading( false )
      setTracks( songsArray )
      setTotalResults( songsArray.length )
    }
    latestTopSongss()
  }, [] )

  const indexOfLastSong = currentPage * resultsPerPage
  const indexOfFirstSong = indexOfLastSong - resultsPerPage
  const currentSongs = tracks.slice( indexOfFirstSong, indexOfLastSong )
  const nextPage = ( pageNumber ) => setCurrentPage( pageNumber )

  const playCurrentTrack = ( index ) => {
    let currentTrack = tracks[index]
    let tracksArr = [...state.tracks, currentTrack]
    let dedupedArr = [...new Set( tracksArr )]
    let idx = dedupedArr.indexOf( currentTrack )
    state.tracks = dedupedArr
    playTrack( idx )
    setState( state => ( { ...state } ) )
    // let newIndex = deduped.indexOf( track => track.id === currentTrack.id )
  }

  return (
    loading
      ? <Loading />
      : <Stack mb={2}>
        <Heading
          fontWeight="light"
          zIndex="auto"
          pt={9}>
          LATEST NEW MUSIC IN EUROPE
        </Heading>
        <article className="queue__wrapper">
          <table className="global__list" id="album__detailsList">
            {currentSongs && currentSongs.map( ( track, i ) => {
              // console.log( track?.privilege?.id )
              let { artists } = track
              return (
                <tbody key={track?.privilege?.id}
                  id="global__listBody">
                  <tr className="queue__item">
                    <td className="queue__item tracknr">
                      {i + 1}
                    </td>
                    <td className="queue__item title">
                      <p>{track?.name}</p>
                      <span>
                        {artists.map( ( { name } ) => name ).join( " & " )}
                      </span>
                      {/* <span>{track?.album?.name}</span> */}
                    </td>
                    <td className="queue__item length">
                      {getTime( track?.duration )}
                    </td>
                    <td className="queue__item play">
                      <button
                        type="button"
                        className="queue__item btn"
                        onClick={() => playCurrentTrack( i )}
                      >
                        {currentTrackName === track?.name && isPlaying
                          ? <RiPauseLine
                            className="paus__btn"
                          />
                          : <RiPlayLine
                            className="play__btn"
                          />
                        }
                      </button>
                    </td>
                    <td>
                      <RiHeartLine
                        style={{
                          fill: "currentColor",
                          width: "1em",
                          height: "1em"
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              )
            } )
            }
          </table>
        </article>
        {totalResults > resultsPerPage
          ? <Pagination
            resultsPerPage={resultsPerPage}
            totalResults={totalResults}
            nextPage={nextPage}
          />
          : null}
      </Stack>
  )
}